module.exports = __webpack_public_path__ + "img/GS_Profile-Ashby Barden.86071b5a.png";